export const V2_RUNTIME_STATUS = Object.freeze({
  IDLE: 'IDLE',
  REPETITION_ACTIVE: 'REPETITION_ACTIVE',
  FINALIZING_REPETITION: 'FINALIZING_REPETITION',
  FINALIZING_PRODUCTION: 'FINALIZING_PRODUCTION',
  SAVING_PRODUCTION: 'SAVING_PRODUCTION',
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED',
});

export const V2_REPETITION_BOUNDARY = Object.freeze({
  MANUAL_NEXT: 'MANUAL_NEXT',
  AUTOMATIC: 'AUTOMATIC',
  TIMER: 'TIMER',
  MONITOR_CONTROLLED: 'MONITOR_CONTROLLED',
});

export const V2_PRODUCTION_BOUNDARY = Object.freeze({
  REPETITIONS_COMPLETE: 'REPETITIONS_COMPLETE',
  MANUAL_NEXT: 'MANUAL_NEXT',
  AUTOMATIC: 'AUTOMATIC',
  MONITOR_CONTROLLED: 'MONITOR_CONTROLLED',
});

export const V2_RESULT_STATUS = Object.freeze({
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  INCOMPLETE: 'INCOMPLETE',
  SKIPPED: 'SKIPPED',
  CANCELLED: 'CANCELLED',
});

export const V2_COMPLETION_REASON = Object.freeze({
  USER_NEXT: 'USER_NEXT',
  AUTOMATIC: 'AUTOMATIC',
  TIMER: 'TIMER',
  REPETITIONS_COMPLETE: 'REPETITIONS_COMPLETE',
  USER_SKIP: 'USER_SKIP',
  USER_CANCEL: 'USER_CANCEL',
});